var map = {
	"./Group 1.svg": 4902,
	"./PDF.svg": 6400,
	"./Print.svg": 1903,
	"./arrov.svg": 7308,
	"./arrowForCalendar.svg": 476,
	"./calc.svg": 6885,
	"./calcActive.svg": 3603,
	"./car-green.svg": 1070,
	"./car-red.svg": 8238,
	"./car.svg": 9820,
	"./checkbox.svg": 9789,
	"./close.svg": 3866,
	"./csv.svg": 4398,
	"./edit.svg": 7322,
	"./filter.svg": 1420,
	"./filterActive.svg": 7274,
	"./folder.svg": 4166,
	"./fuel.svg": 9694,
	"./gas-station-green.svg": 4456,
	"./gas-station.svg": 9674,
	"./logo-title.svg": 1770,
	"./logo.svg": 3935,
	"./logout.svg": 3180,
	"./refueller.svg": 9434,
	"./report.svg": 40,
	"./search-big--red.svg": 5150,
	"./search-big.svg": 7651,
	"./search.svg": 8246,
	"./subtract-red.svg": 8464,
	"./subtract.svg": 5586,
	"./xls.svg": 221
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1980;